import { Component, OnInit } from '@angular/core';
import { SelectButtonOptionClickEvent } from 'primeng/selectbutton';
import { mergeMap } from 'rxjs';
import { Article } from 'src/app/modules/entities/article';
import { ArticleType } from 'src/app/modules/entities/article-type';
import { ArticleTypeService } from 'src/app/modules/services/article-type.service';
import { ArticleService } from 'src/app/modules/services/article.service';
import { url } from 'src/app/modules/util/constants';
import { environment } from 'src/environments/environment.development';

@Component({
  selector: 'app-article-list',
  templateUrl: './article-list.component.html',
  styleUrls: ['./article-list.component.css']
})
export class ArticleListComponent implements OnInit {

  constructor (private articleTypeService: ArticleTypeService, private articleService: ArticleService) { }
  
  articleTypeList: ArticleType[] = [];
  articleList: Article[] = [];
  selectedArticleType: number = 0;
  emptyArticleType: ArticleType = {id: 0, description: 'Todo'};
  uploadLocation: string = environment.cfgApiBaseUrl + '/uploads/';
  thumbnailLocation: string = this.uploadLocation + 'thumbnails/';
  
  ngOnInit(): void {
    this.articleTypeService.getArticleTypes().subscribe({
      next: response => {
        if (response.status === 'success')
          this.articleTypeList = response.data;
        this.articleTypeList.unshift(this.emptyArticleType);
      }
    });
    this.articleService.getAllArticles().subscribe({
      next: response => {
        if (response.status === 'success')
          this.articleList = response.data as Article[];
      }
    });
  }

  filterByArticleType(event: SelectButtonOptionClickEvent) {

  }

  getUrlArticle(urlId: string): string {
    return '/'+ url['blog'] + '/' + urlId;
  }

  handleError(event: Event) {
    (event.target! as any).src = 'assets/images/not-found.png';
  }
}
